<template>
    <div class="patent-info-panel" :style="{paddingLeft:(isShowImg && isSingleImg && imgPositon === 'left') ? '190px':'0',paddingRight:(isShowImg && isSingleImg && imgPositon === 'right') ? '200px':'0',
    minHeight:(isShowImg && isSingleImg)?'200px':'0'}">
        <!-- 左侧图片 -->
        <div class="pic-container" v-if="isShowImg && isSingleImg && imgPositon === 'left'">
            <img v-if="urlList[0]" :src="urlList[0]" :data-original="urlList[0]" :href="urlList[0]"
            @click="browseImg(urlList,0)">
            <div v-else class="no-img">
                <i class="el-icon-picture"></i>
                <p>暂无图片</p>   
            </div>
            <div class="imgTag" v-if="imgTag && !!imgTag.text" :class="imgTag.color">{{imgTag.text}}</div>
        </div>
         <!-- 右侧图片 -->
        <div class="pic-container right" v-if="isShowImg && isSingleImg && imgPositon === 'right'">
            <img v-if="urlList[0]" :src="urlList[0]" :data-original="urlList[0]" :href="urlList[0]"
            @click="browseImg(urlList,0)">
              <div v-else class="no-img">
                <i class="el-icon-picture"></i>
                <p>暂无图片</p>   
            </div>
            <div class="imgTag" v-if="imgTag && !!imgTag.text" :class="imgTag.color">{{imgTag.text}}</div>
        </div>
        <section class="img-left">
            <div class="title">
                <slot name="title">
                    {{index}}、<span v-html="title">{{title}}</span>
                </slot>
                <span v-if="titleTag.length > 0" v-for="item in titleTag" class="pat-label" :class="item.color">
                    {{item.text}}
                </span>
            </div>
            <el-row :gutter="15">
                <template v-for="item in fieldList">
                    <el-col :span="item.rowspan" class="info-item">
                        <span class="label">{{item.label}}：</span>
                        <slot name="single-field" :data="item">
                            <a v-if="!!item.isAllowedDrilling" @click="drilling(item)">{{item.value}}</a>
                            <span v-if="!item.isAllowedDrilling">{{item.value}}</span>
                        </slot>                    
                    </el-col>
                </template>
            </el-row>
            <el-row class="tool" v-if="isShowTool">
                <slot name="tool">   
                    <el-button type="text" @click="download"><i class="el-icon-download"></i>下载</el-button>
                </slot> 
            </el-row>
        </section>
        <section class="img-list" v-if="isShowImg && !isSingleImg">
            <ul>
                <li v-for="(item,index) in urlList" class="img-list-item">
                    <img :src="item" :data-original="item" :href="item" @click="browseImg(urlList,index)">
                </li>
            </ul>
        </section>
    </div>
</template>
<script>
export default {
    name:'ipPatentInfoPanel',
    props:{ 
        index:{type:Number,default:0},
        title:{type:String,default:''},
        titleTag:{type:Array,default(){return []}},
        fieldList:{type:Array,default(){return []}},
        isShowImg:{type:Boolean,default:false},
        imgTag:{type:Object,default(){return {}}},
        isSingleImg:{type:Boolean,default:true},
        imgPositon:{type:String,default:'left'},
        urlList:{type:Array,default(){return []}},
        isShowTool:{type:Boolean,default:true}
    },
    data(){
        return{
        }
    },
    methods:{
        drilling(item){
            this.$emit('drilling',item)
        },
        download(){
            this.$emit('download')
        },
        browseImg(list,index){
            this.$emit('browse-img',list,index)
        }
    }
}
</script>
<style lang="scss">
.patent-info-panel{
    .tool{
        margin: 10px 0;
        .el-button--text{
            padding: 2px 4px;
            color: $theme-color;
            font-size: $sm-font-size;
        }
        .el-button--text:hover{
             background: $theme-color;
             color: #ffffff;
        }
    }
}
</style>

<style lang="scss" scoped>
.patent-info-panel{
    .yellow {
        background: #f89406;
    }
    .grey {
        background: #A3ABAE;
    }
    .red {
        background: #DF5320;
    }
    .blue {
        background: #5C9BD1;
    }
    .skyblue {
        background: #32c5d2;
    }
    .green {
        background: #26C281;
    }
    position: relative;
    padding-bottom:15px;
    .pic-container{
        width: 170px;
        height: 200px;
        border: 1px solid #d9d9d9;
        padding: 10px;
        background: #ffffff;
        position: absolute;
        left: 0;
        top: 0;
        box-sizing: border-box;
        img{
            max-width: 100%;
            margin-left: auto;
            margin-right: auto;
            max-height: 100%;
            display: block;
        }
        .no-img{
            font-size:$sm-font-size;
            margin-top: 44px;
            color: #999;
            text-align: center;
            i{
                color: #cccccc;
                font-size: 60px;
            }
            p{
                margin:0;
            }
        }
        .imgTag{
            position:absolute;
            bottom:0;
            left: 0;
            text-align:center;
            width:100%;
            color:#fff;
            font-size:$sm-font-size;
            height: 24px;
            line-height:24px;
        }
    }
    .right{
        right:20px;
        left: auto;
    }
    .title{
        font-size: $md-font-size;
        color: $theme-color;
        display: block;
        margin-bottom: 8px;
        cursor: pointer;
        .pat-label{
            display: inline-block;
            font-size: $sm-font-size;
            color: #ffffff;
            padding: 2px 6px;
            margin: 0 4px;
        }
    }
    .info-item{
        font-size: $sm-font-size;
        padding: 4px 0;
        line-height: 24px;
        .label{
            color: #666666;
        }
        span{
            line-height:20px;
        }
        a{
            color: $theme-color;
            cursor: pointer;
        }
    }
    .img-list{
        overflow: hidden;
        ul{
            padding: 0;
            margin: 0;
            li{
                list-style: none;
                padding: 0;
                margin: 0;
            }
            .img-list-item{
                float: left;
                width: 150px;
                padding: 10px;
                border: 1px solid #d9d9d9;
                height: 150px;
                margin: 0 10px 10px 0;
            }
        }
    }
}
</style>

